interface SysLangType {
  [x: string]: number;
}

export const sysLang: SysLangType = {
  en: 1,
  bn: 13,
};
